import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as GlobalVariables from "../global";
import { Http, Headers, ResponseContentType } from "@angular/http";
import { JwtModule } from "@auth0/angular-jwt";
import { JwtHelperService } from "@auth0/angular-jwt";
import { environment } from "src/environments/environment";
import { MatSnackBar } from "@angular/material";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  headers = new Headers({
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": environment.cors,
  });
  headers2 = new Headers({
    "Content-Type": "application/octet-stream",
    "Access-Control-Allow-Origin": environment.cors,
    responseType: "blob",
  });
  headers1 = new Headers({
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": environment.cors,
    Authorization: "Bearer" + " " + sessionStorage.getItem("token"),
  });

  constructor(
    private http: Http,
    private snackBar: MatSnackBar,
    private httpClient: HttpClient
  ) {}
  createAuthorizationHeader(headers: Headers) {
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", environment.cors);
    headers.append(
      "Authorization",
      "Bearer" + " " + sessionStorage.getItem("token")
    );
  }
  login(jsonObject) {
    return this.http.post(GlobalVariables.loginUrl, jsonObject, {
      headers: this.headers,
    });
  }

  getOverallFinanceExpenditureData(jsonObject) {
    return this.http.post(GlobalVariables.getFinDataUrl, jsonObject, {
      headers: this.headers,
    });
  }

  getOverallFinanceTargetData(jsonObject) {
    return this.http.post(GlobalVariables.getFinTargetDataUrl, jsonObject, {
      headers: this.headers,
    });
  }

  addKabhiNewPatientData(patientData: any) {
  const url = `${environment.baseUrl}/addKabhiNewPatientData`;
  return this.http.post(url, patientData);
}

  addPatData(jsonObject) {
    return this.http.post(GlobalVariables.addPatientRecordUrl, jsonObject, {
      headers: this.headers,
    });
  }

  checkReportStatusByMY(jsonObject) {
    return this.http.post(
      GlobalVariables.checkReportStatusByMYUrl,
      jsonObject,
      { headers: this.headers }
    );
  }

  addFinData(jsonObject) {
    return this.http.post(GlobalVariables.addFinanceRecordUrl, jsonObject, {
      headers: this.headers,
    });
  }

  addMNSData(jsonObject) {
    return this.http.post(GlobalVariables.addMNSRecordUrl, jsonObject, {
      headers: this.headers,
    });
  }

  getFinanceRankingReport(jsonObject) {
    return this.http.get(
      GlobalVariables.getFinanceRankingReportUrl,
      jsonObject
    );
  }

  getFacilityDetailsByTaluka(jsonObject) {
    return this.http.post(
      GlobalVariables.getFacilityDetailsByTaluka,
      jsonObject,
      { headers: this.headers }
    );
  }
  getMNSApprovalData(jsonObject) {
    return this.http.post(GlobalVariables.getMNSApprovalData, jsonObject, {
      headers: this.headers,
    });
  }
  getDMHPExpApprovalData(jsonObject) {
    return this.http.post(GlobalVariables.getDMHPExpApprovalData, jsonObject, {
      headers: this.headers,
    });
  }
  getPatientDataByReportID(jsonObject) {
    return this.http.post(
      GlobalVariables.getPatientDataByReportID,
      jsonObject,
      { headers: this.headers }
    );
  }
  getExpenditureDataByBudgID(jsonObject) {
    return this.http.post(GlobalVariables.getfinanceDataByID, jsonObject, {
      headers: this.headers,
    });
  }
  getFinanceDataByDistrictId(jsonObject) {
    return this.http.post(
      GlobalVariables.getFinanceDataByDistrictIdUrl,
      jsonObject,
      { headers: this.headers }
    );
  }
  updateStatus(jsonObject) {
    return this.http.post(GlobalVariables.getStatusByReportID, jsonObject, {
      headers: this.headers,
    });
  }
  getFacilityDetailsByDistrict(jsonObject) {
    return this.http.post(
      GlobalVariables.getFacilityDetailsByDistrict,
      jsonObject,
      { headers: this.headers }
    );
  }
  getPatientDataByTaluka(jsonObject) {
    return this.http.post(GlobalVariables.getPatientDataByTaluka, jsonObject, {
      headers: this.headers,
    });
  }
  getCHCPatientDataByTaluka(jsonObject) {
    return this.http.post(GlobalVariables.getPatientDataByTaluka, jsonObject, {
      headers: this.headers,
    });
  }
  getEventList() {
    return this.http.get(GlobalVariables.getEventListUrl, {
      headers: this.headers,
    });
  }
  getResourceMaterialList() {
    return this.http.get(GlobalVariables.getResourceMaterialUrl, {
      headers: this.headers,
    });
  }
  getDesignationList() {
    return this.http.get(GlobalVariables.getDesignationUrl, {
      headers: this.headers,
    });
  }
  getSensitizationList() {
    return this.http.get(GlobalVariables.getSensitizationUrl, {
      headers: this.headers,
    });
  }
  getFacilityTypeList() {
    return this.http.get(GlobalVariables.getFacilityTypeUrl, {
      headers: this.headers,
    });
  }
  getProgramTypeList() {
    return this.http.get(GlobalVariables.getProgramTypeUrl, {
      headers: this.headers,
    });
  }
  getPersonVisitedList() {
    return this.http.get(GlobalVariables.getPersonVisitedUrl, {
      headers: this.headers,
    });
  }
  getHWCDashData() {
    return this.http.get(GlobalVariables.getHWCDashDataUrl, {
      headers: this.headers,
    });
  }
  getPatientDataOverview(jsonObject) {
    return this.http.post(
      GlobalVariables.getPatientDataOverviewUrl,
      jsonObject,
      { headers: this.headers }
    );
  }
  getPatientDataOverviewDist(jsonObject) {
    return this.http.post(
      GlobalVariables.getPatientDataOverviewDistUrl,
      jsonObject,
      { headers: this.headers }
    );
  }
  getHWCDistDashData(jsonObject) {
    return this.http.post(GlobalVariables.getHWCDistDashDataUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getTalukaByDistrictList(jsonObject) {
    return this.http.post(GlobalVariables.getTalukaByDistrictUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getCHCByTalukaDataList(jsonObject) {
    return this.http.post(GlobalVariables.getCHCByTalukaUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getPHCByTalukaDataList(jsonObject) {
    return this.http.post(GlobalVariables.getPHCByTalukaUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getFacilityById(jsonObject) {
    return this.http.post(GlobalVariables.fetchFacilityUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getTalukaById(jsonObject) {
    return this.http.post(GlobalVariables.fetchTalukaUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getFacilityTypeById(jsonObject) {
    return this.http.post(GlobalVariables.fetchFacilityTypeUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getDistrictById(jsonObject) {
    return this.http.post(GlobalVariables.fetchDistrictUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getTGGroup(jsonObject) {
    return this.http.post(GlobalVariables.getTargetGroupUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getPatientByFacility(jsonObject) {
    return this.http.post(
      GlobalVariables.getPatientDataByFacility,
      jsonObject,
      { headers: this.headers }
    );
  }
  getPatientByMNC(jsonObject) {
    return this.http.post(GlobalVariables.getPatientDataByMNC, jsonObject, {
      headers: this.headers,
    });
  }
  getTrainingsReport(jsonObject) {
    return this.http.post(GlobalVariables.getPhysicalReportUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getPatientReport(jsonObject) {
    return this.http.post(GlobalVariables.getPatientReportUrl, jsonObject, {
      headers: this.headers,
    });
  }
  getDrugStockStatusState() {
    return this.http.post(GlobalVariables.getDrugStockDataUrl, {
      headers: this.headers,
    });
  }
  getHWCPateintReport() {
    return this.http.post(GlobalVariables.getHWCPateintReportUrl, {
      headers: this.headers2,
    });
  }

  getDetailedReport(reportRequest: any): Observable<any> {
    const url = `${environment.baseUrl}/getDetailedReport`;
   

    return this.http
      .post(url, reportRequest, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error("An error occurred:", error);
    if (error.error instanceof ErrorEvent) {
     
      console.error("An error occurred:", error.error.message);
    } else {
      
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    
    return throwError(error);
  }

  getFacilityReport(request: { facilityId: string }): Observable<any> {
    const url = `${environment.baseUrl}/fetchFacilityById`;
    

    return this.http
      .post(url, request, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  downloadFile(jsonObject): Observable<any> {
    //return this.http.post(GlobalVariables.getHWCPateintReportUrl,jsonObject, {responseType: ResponseContentType.Blob});
    return this.http.get(
      GlobalVariables.getHWCPateintReportUrl +
        "/" +
        jsonObject.fromdate +
        "/" +
        jsonObject.todate,
      { responseType: ResponseContentType.Blob }
    );
  }

  downloadFileDist(jsonObject): Observable<any> {
    //return this.http.post(GlobalVariables.getHWCPateintReportUrl,jsonObject, {responseType: ResponseContentType.Blob});
    return this.http.get(
      GlobalVariables.getHWCDistPateintReportUrl +
        "/" +
        jsonObject.fromdate +
        "/" +
        jsonObject.todate +
        "/" +
        jsonObject.distId,
      { responseType: ResponseContentType.Blob }
    );
  }

  downloadDistPatientData(jsonObject): Observable<any> {
    //return this.http.post(GlobalVariables.getHWCPateintReportUrl,jsonObject, {responseType: ResponseContentType.Blob});
    return this.http.get(
      GlobalVariables.getDistPateintReportUrl +
        "/" +
        jsonObject.fromdate +
        "/" +
        jsonObject.todate +
        "/" +
        jsonObject.distId,
      { responseType: ResponseContentType.Blob }
    );
  }

  isLoggedIn() {
    const helper = new JwtHelperService();
    const token = sessionStorage.getItem("token");
    const decodedToken = helper.decodeToken(token);
    const expirationDate = helper.getTokenExpirationDate(token);
    const isExpired = helper.isTokenExpired(token); //false;
    if (!token) {
      return false;
    } else {
      if (isExpired) {
        this.snackBar.open("Session Expired Please Login to Continue", "x", {
          duration: 6000,
        });
        return false;
      }
      return true;
    }
  }

  logout() {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(
      GlobalVariables.logoutUrl +
        "/" +
        sessionStorage.getItem("userID") +
        "/" +
        sessionStorage.getItem("sessionToken"),
      { headers: headers }
    );
  }

  getSalt(username) {
    return this.http.get(GlobalVariables.genSaltUrl + username);
  }
  changePassword(obj) {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.post(GlobalVariables.changePassUrl, obj, {
      headers: headers,
    });
  }
  getCaptcha(purpose) {
    return this.http.post(
      GlobalVariables.getCaptchaUrl + purpose,
      {},
      { headers: this.headers }
    );
  }

  getNewToken() {
    // const headers = new Headers();
    // this.createAuthorizationHeader1(headers);
    const path =
      GlobalVariables.refreshToken +
      sessionStorage.getItem("sessionId") +
      "/" +
      sessionStorage.getItem("sessionToken") +
      "/" +
      sessionStorage.getItem("userName");
    return this.httpClient.get(path);
  }

  refreshToken(): Observable<any> {
    // const refreshToken = sessionStorage.getItem('refreshToken');
    const path =
      GlobalVariables.refreshToken +
      sessionStorage.getItem("sessionId") +
      "/" +
      sessionStorage.getItem("sessionToken") +
      "/" +
      sessionStorage.getItem("userName");
    return this.httpClient.get(path);
  }

  isAdmin() {
    if (sessionStorage.getItem("role") === "Admin") {
      return true;
    } else {
      return false;
    }
  }
  isMHP() {
    if (sessionStorage.getItem("role") === "MHProfessional") {
      return true;
    } else {
      return false;
    }
  }

  isUpdate() {
    if (sessionStorage.getItem("isUpdate") === "true") {
      return true;
    } else {
      return false;
    }
  }
}
